import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import {
  decimalInvertedReportFormatter,
  percentageReportFormatter,
} from "../../fomatters/DecimalFormatter";
import GroupedReport from "../GroupedReport";
import SubGroup from "../SubGroup";

const startDateValue = new Date().toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function DistributorHoldPercent() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [fromDistributor, setFromDistributor] = useState("");
  const onFromDistributorChange = useCallback(
    (event) => setFromDistributor(event.target.value),
    []
  );

  const [toDistributor, setToDistributor] = useState("");
  const onToDistributorChange = useCallback(
    (event) => setToDistributor(event.target.value),
    []
  );

  const [groupBy, setGroupBy] = useState(0);
  const onGroupByChange = useCallback(
    (event) => setGroupBy(Number(event.target.value)),
    []
  );

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          className="flex-1"
          required
          variant="outlined"
          id="gameDateTime"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Distrib From"
          type="text"
          value={fromDistributor}
          size="small"
          onChange={onFromDistributorChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Distrib To"
          type="text"
          value={toDistributor}
          size="small"
          onChange={onToDistributorChange}
          InputLabelProps={{ shrink: true }}
        />
        <div>
          <SubGroup title="Order By">
            <FormControl component="fieldset">
              <RadioGroup label value={groupBy} onChange={onGroupByChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Sport"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Period"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Bet Type"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={3} size="small" color="primary" />}
                  label="Play"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <GroupedReport
        title="Distributor Hold Percent Report"
        getUrl={() => "/Reports/Report_Distributor_Hold_Percent"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          FromDistributor: fromDistributor,
          ToDistributor: toDistributor,
          GroupBy: groupBy,
        })}
        getProcess={(item) => ({
          ...item,
          holdPercentage: `${Math.round((item.winLost / item.amount + Number.EPSILON) * 10000) /
            100
            }%`,
        })}
        getTotals={(data) => {
          const amount = data.reduce((acc, item) => acc + item.amount, 0);
          const winLost = data.reduce((acc, item) => acc + item.winLost, 0);

          return {
            group4: "SubTotal",
            amount,
            winLost,
            holdPercentage:
              Math.round((winLost / amount + Number.EPSILON) * 10000) / 100,
          };
        }}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="group3">
          Period
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="group4">
          Play
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="amount"
          dataFormat={decimalInvertedReportFormatter}
        >
          Risked
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="winLost"
          dataFormat={decimalInvertedReportFormatter}
        >
          Win / Loss
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="holdPercentage"
          dataFormat={percentageReportFormatter}
        >
          HoldPct
        </TableHeaderColumn>
      </GroupedReport>
    </div>
  );
}

export default DistributorHoldPercent;
